import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import styles from '../../styles/components/atoms/Empty.module.scss';

interface EmptyProps {
  className?: string;
  label?: string;
  dark?: boolean;
  onClick?: () => void;
}

export default function Tag(props: EmptyProps) {
  const { t } = useTranslation('common');
  const { label, dark, onClick, className } = props;
  const classes = clsx(
    styles.empty,
    { [styles.dark]: dark },
    { [styles.clickable]: !!onClick },
    className
  );

  return (
    <div onClick={onClick} className={classes}>
      {label || t('common:no_info_provided')}
    </div>
  );
}
